import React, { useCallback, useState } from 'react'
import { Field } from 'redux-form'
import renderSelectorField from 'components/FormControls/selector'
import { Icon, Tooltip, Typography } from 'gu-ui-kit'
import { numberWithSpace } from 'utils/numberWithSpace'
import styles from 'modules/MediaPlanner/MediaPlanner.module.scss'
import RadioGroup from 'components/FormControls/subcomponents/RadioGroup'
import renderInputField from 'components/FormControls/textInput'
import { onlyNumbers } from 'utils/normalize/onlyNumbers'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export const ComboSelector = ({
  autofill,
  change,
  options,
  sub_field,
  formValues,
  onChange,
  formErrors,
  label,
  name,
}) => {
  const [subComponentFocus, setSubComponentFocus] = useState(false)
  const { t } = useTranslation()
  const handleSelect = useCallback(
    (value) => {
      if (!value?.length) {
        return
      }
      autofill(
        `${sub_field.name}_min`,
        options?.find((option) => option.value === value)?.min,
      )
      autofill(
        `${sub_field.name}_max`,
        options?.find((option) => option.value === value)?.max,
      )
      autofill(`${name}_selected`, value)
      setSubComponentFocus(true)
    },
    [sub_field, name, options],
  )
  const handleBlur = useCallback(() => setSubComponentFocus(false), [])

  const handleFocus = useCallback(
    () => change(sub_field.name, formValues[sub_field.name] || ''), // триггернуть смену ошибки
    [sub_field, formValues],
  )

  return (
    <>
      {/*это поле нужно, для того чтобы отображалась корректно ошибка, если оригинальное поле скрыто*/}
      <Field name={sub_field.name} component={() => null} />
      <Field
        onChange={() => onChange(name)}
        size={'l'}
        label={label}
        name={name}
        items={options?.map(({ value, ...rest }) => ({
          ...rest,
          value,
          label: t(`media_planner::form.${name}.options.${value}.label.full`),
          label_short: t(
            `media_planner::form.${name}.options.${value}.label.short`,
          ),
        }))}
        fullWidth
        component={renderSelectorField}
        helperText={
          formErrors[sub_field.name] ? (
            <Typography
              variant={'Body-Description-10'}
              color={'Label-Error-Primary'}
            >
              {t(formErrors[sub_field.name])}
            </Typography>
          ) : null
        }
        renderSelectedValue={({ value, items }) => {
          const { label_short = '' } =
            items?.find((item) => item.value === value) ?? {}
          return `${
            formValues[sub_field.name]?.length > 0
              ? numberWithSpace(formValues[sub_field.name]) +
                (value === 'budget' ? ' ₽, ' : ', ')
              : ''
          }${label_short}`
        }}
        t={t}
        dropdownClassName={styles['media-planner__dropdown']}
        renderDropdown={({
          items,
          renderLabel,
          onClose,
          onChange,
          value,
          onDrop,
          ...rest
        }) => (
          <RadioGroup
            value={value}
            options={items}
            renderLabel={renderLabel}
            onSelect={handleSelect}
            onDrop={() => {
              autofill(sub_field.name, '')
              onDrop()
            }}
            onApply={(value) => {
              onClose()
              onChange(value)
            }}
            {...rest}
          >
            <div
              className={
                'padding-left-24 padding-right-24 padding-bottom-8 padding-top-8'
              }
            >
              <Field
                label={t(`media_planner::form.${sub_field.name}.label`)}
                fullWidth
                name={sub_field.name}
                type="text"
                focus={subComponentFocus}
                onFocus={handleFocus}
                onBlur={handleBlur}
                component={renderInputField}
                t={t}
                autocomplete="off"
                format={(value = '') => numberWithSpace(value)}
                parse={onlyNumbers}
                normalize={onlyNumbers}
                InputProps={{
                  endAdornment: (
                    <Tooltip
                      title={t(`media_planner::form.${sub_field.name}.tooltip`)}
                    >
                      <Icon
                        className={styles['media-planner__icon']}
                        size={'m'}
                        name={'status warning'}
                        color={'Interface-Seventh'}
                      />
                    </Tooltip>
                  ),
                }}
              />
            </div>
          </RadioGroup>
        )}
      />
    </>
  )
}

ComboSelector.propTypes = {
  autofill: PropTypes.func,
  change: PropTypes.func,
  options: PropTypes.array,
  sub_field: PropTypes.object,
  formValues: PropTypes.object,
  onChange: PropTypes.func,
  formErrors: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string,
}
